export interface GetUnitsReq {
  productCode: string;
  agreementCode?: string;
  agreementItemCode?: string;
  plantId?: number;
}
